import Icon from '../components/Icon.vue'

Icon.register({
  vials: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M72 64H96V304C96 348.1 131.9 384 176 384S256 348.1 256 304V64H280C284.4 64 288 60.4 288 56V8C288 3.6 284.4 0 280 0H72C67.6 0 64 3.6 64 8V56C64 60.4 67.6 64 72 64zM144 64H208V160H144V64zM624 448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM360 64H384V304C384 348.1 419.9 384 464 384S544 348.1 544 304V64H568C572.4 64 576 60.4 576 56V8C576 3.6 572.4 0 568 0H360C355.6 0 352 3.6 352 8V56C352 60.4 355.6 64 360 64zM432 64H496V160H432V64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vials.js
// module id = 5qSg
// module chunks = 144